import * as customPropTypes from 'custom-prop-types';
import React from 'react';

import { useDirectoryContext } from '../../context/DirectoryContext';
import { useDirectoryState } from '../../hooks/useDirectoryState';
import { DirectorySearchResults } from '../DirectorySearchResults';
import { LocationList } from '../LocationList';

const DirectoryMain = ({ analytics, ...props }) => {
    const state = useDirectoryState();
    const { results } = useDirectoryContext();

    return state === 'default' ? (
        <LocationList listItems={results} analytics={analytics} />
    ) : (
        <DirectorySearchResults results={results} analytics={analytics} />
    );
};

DirectoryMain.propTypes = {
    analytics: customPropTypes.analyticsPropType,
};

export default DirectoryMain;
